/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setThree.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import * as THREE from 'three';
import gsap from "gsap";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader.js';
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const html = document.querySelector("html");
const main = document.querySelector("main");
const canvas = document.querySelector(".areamap__canvas-area");
const startArea = document.querySelector(".intro__start-area");
const objectArea = document.querySelector(".areamap__object-area");
const svgLoader = new SVGLoader();
const commentJson = require('/assets/json/comment.json');
const modal = document.querySelector("#comment .modal");


/**
 * 処理
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function setAreaMap() {

    let main_W, main_H // ドキュメントサイズ
    let scene, light, camera, renderer // シーン、カメラ、レンダラー
    let fov, fovRad, distance // カメラの視野角
    let controls // オービットコントロール
    let panX, panY, panZ // カメラのパン
    let raycaster, raymouse, intersects // レイキャスター, マウス, インターセクト
    let clickArea = new THREE.Group(); // クリックエリア
    let clickAreaMeshList = []; // クリックエリアメッシュリスト
    let controlsFlag = false; // オービットコントロールフラグ

    window.addEventListener('load', () => {
        init();
        createClickArea();
        createTextArea();
        createIlust();
        panControl();
        startArea.addEventListener('click', () => {
            if (clickAreaFlag === true && textAreaFlag === true && ilustFlag === true) {
                renderScene();
            }
        });
    });

    /**
     * 初期設定
     */
    function init() {

        //画面サイズ取得
        main_W = main.clientWidth;
        main_H = main.clientHeight;

        //カメラ作成
        fov = 150; //カメラの視野角
        fovRad = (fov / 2) * (Math.PI / 180); // 視野角をラジアンに変換
        distance = main_H / Math.tan(fovRad); // カメラ距離を求める
        camera = new THREE.PerspectiveCamera(fov, main_W / main_H, 0.1, 1000); // カメラを作成
        camera.position.set(0, 0, distance); // カメラの位置を設定

        //シーン作成
        scene = new THREE.Scene();

        //ライト
        light = new THREE.AmbientLight(0xffffff, 1);
        light.position.set(0, 0, 1);
        scene.add(light);

        //レンダラー作成
        renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
        renderer.setClearColor(0xffffff, 0);
        renderer.setSize(main_W, main_H);
        renderer.setPixelRatio(window.devicePixelRatio);

        //レンダラーをDOMに追加
        canvas?.appendChild(renderer.domElement);

        //カメラコントローラーを設定
        controls = new OrbitControls(camera, renderer.domElement);
        controls.autoRotate = false;
        controls.enableRotate = false;
        controls.touches = {
            ONE: THREE.TOUCH.PAN,
            TWO: THREE.TOUCH.DOLLY_ROTATE
        }
        controls.mouseButtons = {
            LEFT: THREE.MOUSE.PAN,
        }
        controls.maxDistance = distance;
        controls.minDistance = distance / 12;
        controls.panSpeed = 1;
        controls.enableDamping = true;
        controls.dampingFactor = 0.1;

        // レイキャスターを作成
        raycaster = new THREE.Raycaster();

        // リサイズイベント
        window.addEventListener("resize", resizeWindow);

        //クリック時
        canvas.addEventListener('click', function (e) {
            if (!controlsFlag) {
                getIntersectedModalID(e);
                renderer.render(scene, camera);
                setTimeout(function () { controlsFlag = false; }, 75);
            }
        });

        //長押し無効
        canvas.oncontextmenu = function (event) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        };
    }

    /**
    * クリックエリアを生成
    */
    let clickAreaFlag = false;
    function createClickArea() {
        svgLoader.load(
            "../assets/images/areamap/click-area.svg",
            function (data) {
                let paths = data.paths;
                for (let i = 0; i < paths.length; i++) {
                    let path = paths[i];
                    let material01 = new THREE.MeshBasicMaterial({ color: 0x000000, transparent: true, opacity: 0, side: THREE.DoubleSide, depthWrite: false, });
                    let shapes = SVGLoader.createShapes(path);
                    let dataModalId = path.userData.node.getAttribute('data-modal');
                    for (let j = 0; j < shapes.length; j++) {
                        let shape = shapes[j];
                        let geometry = new THREE.ShapeGeometry(shape);
                        let mesh = new THREE.Mesh(geometry, material01);
                        mesh.name = dataModalId;
                        clickAreaMeshList.push(mesh);
                        clickArea.add(mesh);
                    }
                }

                let box = new THREE.Box3().setFromObject(clickArea);
                let boxCenter = box.getCenter(new THREE.Vector3());
                clickArea.position.x = -boxCenter.x;
                clickArea.position.y = -boxCenter.y;
                clickArea.position.z = 3;
            }
        );

        scene.add(clickArea);
        clickAreaFlag = true;
    }

    /**
    * テキストエリアを生成
    */
    let textAreaFlag = false;
    function createTextArea() {
        let texture = new THREE.TextureLoader().load('../assets/images/areamap/text-area.png',
            (tex) => {
                // 縦横比を保って適当にリサイズ
                const w = tex.image.width / 6;
                const h = w * (tex.image.height / tex.image.width);

                // 平面
                const geometry = new THREE.PlaneGeometry(1, 1);
                const material = new THREE.MeshPhongMaterial({ map: texture });
                const plane = new THREE.Mesh(geometry, material);

                //画質を上げる
                plane.material.map.minFilter = THREE.LinearFilter;
                plane.material.map.anisotropy = renderer.capabilities.getMaxAnisotropy();

                //透過
                plane.material.transparent = true;

                //平面の位置を調整
                plane.position.set(0, 0, 2);
                plane.scale.set(w, h, 1);
                scene.add(plane);
            });

        textAreaFlag = true;
    }

    /**
     * イラストを生成
     */
    let ilustFlag = false;
    let ilustProps = [
        { name: '赤べこ', src: '../assets/images/ilust/ilust01.png', x: -210, y: -75, animatin: "rotation", set: 0.1, to: -0.1, duration: 2, ease: "none" },
        { name: '鶴ヶ城', src: '../assets/images/ilust/ilust02.png', x: -120, y: 35, },
        { name: '磐梯山', src: '../assets/images/ilust/ilust03.png', x: -80, y: -70, },
        { name: '猪苗代湖', src: '../assets/images/ilust/ilust04.png', x: -5, y: 40, },
        { name: 'だるま', src: '../assets/images/ilust/ilust05.png', x: 70, y: -113, animatin: "rotation", set: -0.3, to: 0.15, duration: 1, ease: "bounce.out" },
        { name: '日本酒', src: '../assets/images/ilust/ilust06.png', x: 90, y: 75, },
        { name: '桃', src: '../assets/images/ilust/ilust07.png', x: 130, y: 170, animatin: "rotation", set: 0, to: -0.15, duration: 2, ease: "back.in(2)" },
        { name: '滝桜', src: '../assets/images/ilust/ilust08.png', x: 170, y: 7 },
        { name: '紫陽花', src: '../assets/images/ilust/ilust09.png', x: 210, y: 120, },
        { name: 'フラダンス', src: '../assets/images/ilust/ilust10.png', x: 230, y: -125, animatin: "positionX", set: 233, to: 227, duration: 1, ease: "back.inOut(1.5)" },
        { name: '野馬追', src: '../assets/images/ilust/ilust11.png', x: 290, y: 95, animatin: "positionY", set: 92, to: 97, duration: 0.5, ease: "bounce.Out" },
    ]
    function createIlust() {
        ilustProps.forEach((ilustProp) => {
            let texture = new THREE.TextureLoader().load(ilustProp.src,
                (tex) => {
                    const w = tex.image.width / 10;
                    const h = w * (tex.image.height / tex.image.width);

                    const geometry = new THREE.PlaneGeometry(1, 1);
                    const material = new THREE.MeshPhongMaterial({ map: texture });
                    const plane = new THREE.Mesh(geometry, material);

                    plane.material.map.minFilter = THREE.LinearFilter;
                    plane.material.map.anisotropy = renderer.capabilities.getMaxAnisotropy();
                    plane.material.transparent = true;

                    plane.position.set(ilustProp.x, ilustProp.y, 1);
                    plane.scale.set(w, h, 1);
                    scene.add(plane);

                });
        });

        ilustFlag = true;
    }

    /**
     * クリックエリアのインデックスを取得
     */
    function getIntersectedModalID(e) {
        raymouse = new THREE.Vector2();
        raymouse.x = (e.offsetX / main_W) * 2 - 1;
        raymouse.y = -(e.offsetY / main_H) * 2 + 1;
        raycaster.setFromCamera(raymouse, camera);
        intersects = raycaster.intersectObjects(scene.children);
        intersects.length >= 2 && intersects[0].object.name && openModal(intersects[0].object.name);
    }

    /**
     * panコントロール制御
     */
    function panControl() {
        if (window.innerWidth >= 835) {
            controls.addEventListener('start', () => setTimeout(function () { controlsFlag = true; }, 125));
            controls.addEventListener('end', () => setTimeout(function () { controlsFlag = false; }, 150));
        }
    }

    /**
     * リサイズ時の処理
     */
    function resizeWindow() {
        main_W = main.clientWidth;
        main_H = main.clientHeight;
        renderer.setSize(main_W, main_H);
        camera.aspect = main_W / main_H;
        distance = main_H / Math.tan(fovRad);
        camera.updateProjectionMatrix();
        panControl();
        renderScene();
    }

    /**
     * レンダリング
     */
    function renderScene() {
        controls.update();
        setObjectArea();
        renderer.render(scene, camera);
        window.requestAnimationFrame(renderScene);
    }

    /**
     * モーダルを開く
     */
    const openModal = (e) => {
        setModalContent(e);
        modal.classList.add("--active");
        html.classList.add("--open-modal");
    }

    /**
     * jsonからモーダルの内容を取得後、domに書き出す
     */
    function setModalContent(id) {
        let modal__title = document.querySelector("#comment h2");
        let modal__text = document.querySelector("#comment p");
        let modal__movie = document.querySelector("#comment .movie");
        let modal__link = document.querySelector("#comment .link");
        let modal__link__href = document.querySelector("#comment a");
        let modal__link__text = document.querySelector("#comment a .text");
        commentJson.forEach((comment) => {
            if (id === comment.id) {
                //入れ込み
                modal__title.innerHTML = comment.title.replace(/\r?\n/g, '<br>');
                modal__text.innerHTML = comment.text.replace(/\r?\n/g, '<br>');
                modal__movie.innerHTML = comment.movie;
                modal__link__href.setAttribute("href", comment.link);
                modal__link__text.innerHTML = comment.linkText ? comment.linkText.replace(/\r?\n/g, '<br>') : "詳しくはこちら";

                //非表示
                comment.movie ? modal__movie.classList.remove("--none") : modal__movie.classList.add("--none");
                comment.link ? modal__link.classList.remove("--none") : modal__link.classList.add("--none");
                comment.bnr ? modal__link__href.setAttribute("data-bnr", comment.bnr) : modal__link__href.removeAttribute("data-bnr");
            }
        });
    }

    /**
     * カメラ操作に合わせてオブジェクトを移動させる
     */
    function setObjectArea() {
        panX = controls.object.position.x;
        panY = controls.object.position.y;
        panZ = controls.object.position.z * -0.025 + (distance * 0.025 + 3);
        panZ = Math.round(panZ * 100) / 100;
        objectArea.style.transform = `translate(${panX / 10}px,${panY / 10}px) scale(${panZ})`;
    }
}

/**
 * 書き出し
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setAreaMap };